import {CurrentUser} from 'app/classes/current.user/current.user';

export class BaseAnalyticsService {
    public init(): void { return; }
    public setUser(user: CurrentUser): void { return; }
    public sendEvent(event: string, metaData?: any): void { return; }
    public destroy(): void { return; }
}
